import { render } from "./AreaView.vue?vue&type=template&id=35a1df1c&scoped=true"
import script from "./AreaView.vue?vue&type=script&lang=js"
export * from "./AreaView.vue?vue&type=script&lang=js"

import "./AreaView.vue?vue&type=style&index=0&id=35a1df1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a1df1c"]])

export default __exports__